import LandingPageLayout from 'components/LandingPageLayout';
import Triangle from 'components/LandingPageTriangle';
import TitleSection from '../components/LandingPageTitleSection/TitleSection';
import HeadingSection from 'components/LandingPageHeadingSection/HeadingSection';
import ChooseNeighbour from 'components/LandingPageChooseNeighbour';
import PropertyViewer from '../components/LandingpagePropertyViewer';
import Neighbourhood from 'components/LandingPageNeighbourhood/Neighbourhood';
import Head from 'next/head';
import React from 'react';
import StaysLocation from 'components/LandingPageStaysLocation';

const LibertyVillage = () => {
  return (
    <>
      Featured location - Liberty village
      <Head>
        <meta charset="utf-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Featured location - Liberty village</title>
        <meta
          name="description"
          content="Find a place to live in this cool neighborhood of Toronto"
        />
        <meta name="author" content="SoulRooms" />
        <meta property="og:url" content="https://soulrooms.com/liberty-village" />
        <meta property="og:site_name" content="SoulRooms" />
        <meta property="og:title" content="Featured location - Liberty village" />
        <meta
          property="og:description"
          content="Find a place to live in this cool neighborhood of Toronto"
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@soulroomsTO" />
        <meta name="twitter:title" content="SoulRooms" />
        <meta name="twitter:description" content="Find a place to live in this cool neighborhood of Toronto" />
        <meta name="twitter:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta name="twitter:image:alt" content="SoulRooms" />
        <meta name="theme-color" content="#FCBD00" />
        <meta name="google-site-verification" content="w6cEiCyxsJzrruZP6CzL7X8wnD7E8gMMl4q9aU0P59U" />
        <link rel="canonical" href="https://www.soulrooms.com/liberty-village" />
      </Head>
      <LandingPageLayout>
        <StaysLocation
          img={'/static/images/landingPages/LibertyVillage/LibertyVillage.png'}
          title={'LIBERTY VILLAGE'}
          location={
            <p
              className="fs-4 responsiveText text-capitalize  py-4-md py-4 mb-5 mt-5 "
              style={{ fontFamily: 'Josefin Sans', color: '#5E5E5E' }}>
              Location -
              <a
                href="https://www.google.com/maps/place/Junction+Triangle,+Toronto,+ON/@43.6588947,-79.459836,15z/data=!3m1!4b1!4m5!3m4!1s0x882b3438ef17e0f1:0xd40c7d89513dd4c6!8m2!3d43.6613564!4d-79.4492924"
                target="_blank"
                rel="noreferrer">
                {' '}
                <span className="text-decoration-underline fs-4	" style={{ color: '#946F00' }}>
                  Liberty Village & King West Area
                </span>
              </a>
            </p>
          }
          description={
            <p
              className="  responsiveText xl:pt-1 pb-2 xl:pr-1  mb-5"
              style={{ fontFamily: 'Josefin Sans', color: '#5E5E5E' }}>
              One of Toronto's finest neighborhoods - Liberty Village. Home to young professionals from media,
              technology, and design industries who love to live work, and play in the urban core of Toronto.
            </p>
          }
          btnTitle={'Find Properties Here'}
          href="/find-a-soulroom"
        />
        <Triangle imgSrc="/static/images/landingPages/TheJuction/triangle.png" />
        <Triangle imgSrc="/static/images/landingPages/TheJuction/timeshedule.png" />
        {/* TITLE SECTION  */}
        <TitleSection
          title="BOOK BEFORE THEY ARE GONE"
          btnTxt="Book your spot in Liberty village"
          bg="white"
          hrefExt="https://www.realsage.com/properties"
        />
        {/* 3d slider  */}
        <PropertyViewer bg="black" title="FEATURED PROPERTY:">
          <iframe
            width="853"
            height="480"
            src="https://my.matterport.com/show/?m=jq7G6uvqJV7"
            frameBorder={0}
            allowFullScreen
            allow="vr"></iframe>
        </PropertyViewer>
        {/* Neighbourhood section  */}
        <Neighbourhood
          space={true}
          title="Neighbourhood Highlights"
          img1="/static/images/landingPages/nabourhood1.png"
          img2="/static/images/landingPages/nabourhood2.png"
          img3="/static/images/landingPages/nabourhood3.png"
          cardTitle="School Restaurant"
          cardSubTitle="$$"
          details="A bakery, café, bar, and restaurant that 
          consistently serves one of the best brunches in the city."
          cardTitle2="Goodlife Fitness"
          cardSubTitle2="$"
          details2="More than just a gym since it lets you 
          work out with others who share your passion."
          cardTitle3="The Local"
          cardSubTitle3="$$"
          details3="Vibrant crowds and an extensive bar 
          menu make this the neighbourhood’s favourite watering hole! "
        />
        <HeadingSection title="CHOOSE FROM OTHER LOCATIONS" bgcolor="white" />
        <ChooseNeighbour
          imgsrc="/static/images/landingPages/LibertyVillage/juction.png"
          title="The Junction, Toronto, Ontario, Canada"
          discription="The Museum of Contemporary Art, an immaculate bicycle track, fine cafés, and finer microbreweries ensure you are always on a high out here. The Victorian-style townhouses are not too shabby either. Walking distance from Lansdowne TTC station with bus stops right across the street!"
          reverse="false"
          href="/the-junction"
        />
        <ChooseNeighbour
          imgsrc="/static/images/landingPages/TheJuction/winnipegcanada.png"
          title="Pembina avenue, Winnipeg, Manitoba, Canada"
          discription="Minutes away from the entrance to The University of Manitoba. A brand new building with state-of-the-art facilities that are bound to entertain students and professionals alike. "
          reverse="true"
          href="/winnipeg-soulrooms"
        />
        <ChooseNeighbour
          imgsrc="/static/images/landingPages/TheJuction/oldtoronto.png"
          title="Cabbagetown, Old Toronto, Canada"
          discription="Walking distance from Ryerson University, and the University of Toronto. This neighborhood nests a very strong sense of community and was the house of Irish immigrants from the 1840s!"
          reverse="false"
          href="/cabbagetown"
        />
        {/* TITLE SECTION  */}
        <TitleSection
          title="WANT TO KNOW MORE?"
          btnTxt="Chat with us"
          bg="black"
          hrefExt="https://www.messenger.com/login.php?next=https%3A%2F%2Fwww.messenger.com%2Ft%2F404951336769102%2F%3Fmessaging_source%3Dsource%253Apages%253Amessage_shortlink"
        />
      </LandingPageLayout>
    </>
  );
};

export default LibertyVillage;
